import FavoriteEditorPage from 'pages/menu/favorites-page/favorite-editor/favorite-editor';

export default function FavoriteEditor() {
  return <FavoriteEditorPage />;
}
